const getLearnMoreObject = (theme) => {
  const fontFamily = "Roboto";
  return {
    learnMorePageStyle: {
      fontFamily,
      minHeight: "65vh",
      maxWidth: "750px",
      width: "100%",
      margin: "20px auto",
      padding: "0 30px",
    },
    stepsStyle: {
      fontWeight: 500,
      fontSize: "20px",
      lineHeight: "32px",
      letterSpacing: "0.15px",
      color: theme.textColour.learnMoreTextColor,
    },
    bodyAreasText: {
      fontFamily,
      marginTop: "15px",
      marginBottom: "15px",
      fontWeight: 400,
      fontSize: "16px",
      lineHeight: "24px",
      letterSpacing: "0.15px",
      color: theme.textColour.learnMoreTextColor,
    },
    bodyAreasHeading: {
      fontFamily,
      fontWeight: 500,
      fontSize: "20px",
      lineHeight: "32px",
      letterSpacing: "0.15px",
      color: theme.textColour.learnMoreTextColor,
    },

    globalJudgmentsText: {
      fontFamily,
      fontWeight: 400,
      fontSize: "16px",
      lineHeight: "24px",
      letterSpacing: "0.15px",
      color: theme.textColour.learnMoreTextColor,
    },
    aboutAssessmentHeading: {
      fontFamily,
      fontWeight: 400,
      fontSize: "24px",
      lineHeight: "32px",
      letterSpacing: "0.15px",
      color: theme.textColour.learnMoreTextColor,
    },
    boldTextStyle: {
      fontWeight: 500,
      fontFamily,
      fontSize: "20px",
      lineHeight: "32px",
      letterSpacing: "0.15px",
      color: theme.textColour.learnMoreTextColor,
    },
    refrencesTextStyle: {
      fontFamily,
      fontWeight: 400,
      fontSize: "16px",
      lineHeight: "24px",
      letterSpacing: "0.15px",
      color: theme.textColour.learnMoreTextColor,
    },
    aboutAssessmentSubHeading: {
      fontFamily,
      marginBottom: "10px",
      fontWeight: 500,
      fontSize: "24px",
      lineHeight: "32px",
      letterSpacing: "0.15px",
      color: theme.textColour.learnMoreTextColor,
    },
    aboutAssessmentScoring: {
      fontFamily,
      marginBottom: "10px",
      fontWeight: 500,
      fontSize: "20px",
      lineHeight: "32px",
      letterSpacing: "0.15px",
      color: theme.textColour.learnMoreTextColor,
    },
    videoTextStyle: {
      marginTop: "15px",
      marginBottom: "15px",
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "20.02px",
      letterSpacing: "0.17px",
      color: "rgba(0, 0, 0, 0.6)",
    },
    loadingCoverageStyle: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    },
    aboutExamStyle: {
      marginY: "40px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
    },
    headerStyle: {
      display: "flex",
      alignItems: "center",
    },
    loadinText: {
      fontSize: "14px",
      color: theme.textColour?.textTertiary || "#000",
      fontWeight: 400,
      lineHeight: "22px",
      letterSpacing: ".5px",
    },
    cardHeadingStyle: {
      fontWeight: 500,
      fontSize: "20px",
      lineHeight: "32px",
      letterSpacing: "0.15px",
      color: theme.textColour.learnMoreTextColor,
    },
    gridAlign: {
      width: "100%",
      alignItems: { xs: "left", sm: "center" },
      margin: "0 0 15px",
      display: "flex",
    },
    cardStyle: {
      marginTop: "20px",
      marginRight: "10px",
      padding: "16px",
      marginLeft: "10px",
      borderRadius: "24px",
      display: "flex",
      flexDirection: "column",
      height: "100%",
      width: "100%",
    },
    cardContentStyle: {
      fontSize: "14px",
      lineHeight: "20.02px",
      letterSpacing: "0.17px",
      fontWeight: 400,
      color: "rgba(0, 0, 0, 0.6)",
      flexGrow: 1,
    },
    readArticlebtnStyle: {
      padding: "5px 15px",
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "24px",
      letterSpacing: "0.4px",
      backgroundColor: theme.textColour.primaryColor,
    },
    btnBoxStyle: { textAlign: "right", marginTop: "10px" },
    learnMoreHeading: {
      fontFamily,
      fontWeight: 400,
      fontSize: "34px",
      lineHeight: "41.99px",
      letterSpacing: "0.25px",
      color: theme.textColour.learnMoreTextColor,
    },
    pointerCss: { cursor: "pointer", underline: "none" },
  };
};

export const getLeranMoreStyle = getLearnMoreObject;
